/**
 * Model odpowiedzi API (DTO) zwracany przez Vetineo podczas weryfikacji licencji.
 * Przekazuje informacje o statusie, ważności i ostatniej aktywności powiązanej z danym kluczem dostępu.
 */
export class VetineoLicenceKeyResponse {

  /** Autoryzowany klucz licencyjny.
   */
  public key: string;

  /** Data wygaśnięcia licencji (Expiration Date).
   */
  public exp: Date;

  /** Data ostatniej udanej weryfikacji / aktywności ("Ostatnio widziano").
   */
  public seen: Date;

}
